"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Style_1 = require("./Style");

var ScaleLoader_1 = __importDefault(require("react-spinners/ScaleLoader"));

var styled_components_1 = require("styled-components");

var LoadingBarComponent = function LoadingBarComponent(_a) {
  var _b = _a.progress,
      progress = _b === void 0 ? 0 : _b,
      _c = _a.appearance,
      appearance = _c === void 0 ? 'primary' : _c,
      onFinish = _a.onFinish,
      _d = _a.theme,
      theme = _d === void 0 ? {
    mode: 'light'
  } : _d;
  react_1.useEffect(function () {
    if (progress >= 100 && onFinish) {
      onFinish(new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 800);
      }));
    }
  }, [progress, onFinish]);
  var themeToApply = react_1.useContext(styled_components_1.ThemeContext) || theme;
  var color = Style_1.theme({
    theme: __assign({}, themeToApply),
    appearance: appearance
  }).color({
    theme: __assign({}, themeToApply),
    appearance: appearance
  });
  return react_1.default.createElement("div", {
    className: "loading-bar-component-module"
  }, react_1.default.createElement(Style_1.Reset, null), progress > -1 && progress < 101 && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Style_1.LoadingBarStyled, {
    progress: progress,
    appearance: appearance,
    theme: themeToApply
  }), react_1.default.createElement(Style_1.SpinnerContainer, {
    progress: progress,
    theme: themeToApply
  }, react_1.default.createElement(ScaleLoader_1.default, {
    height: 10,
    color: color
  }))));
};

exports.default = LoadingBarComponent;